module.exports = {
  localeName: 'tr-TR',
  momentFormat: 'DD.MM.YYYY'
};
